<template>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :bordered="false">
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            <!-- <a-button type="primary" @click="searchQuery">查询</a-button> -->
            <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
          </div>
          <!-- table区域-begin -->
          <div>
            <a-table ref="table" size="middle" bordered rowKey="id" 
              :columns="columns" :dataSource="dataSource" :pagination="ipagination" 
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,columnWidth:'3%'}" :scroll="{ x: 500 }" 
              :loading="loading" @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">修改</a>
                <a-divider type="vertical" />
                <a @click="handleAddModule(record)">配置模版</a>
                <a-divider type="vertical" />
                <a @click="handleDelete(record.id)">删除</a>
              </span>
              <!-- 状态渲染模板 -->
              <template slot="releaseTime" slot-scope="text, record">
                <span>{{changetime(record.createTime)}}</span>
              </template>
            </a-table>
          </div>
          <!-- table区域-end -->
          <!-- 表单区域 -->
          <addTraceTemplate ref="modalForm" @ok="modalTemplateOk"></addTraceTemplate>
          <addTraceModule ref="addTraceModule" @ok="modalFormOk" @close="modalFormClose"></addTraceModule>
          <!-- <registerModel ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></registerModel>
          <import-file-modal ref="modalImportForm" @ok="modalFormOk" @close="modalFormClose"></import-file-modal> -->
        </a-card>
      </a-col>
    </a-row>
  </template>
  <!-- b y 7 5 2 7  1 8 9 2 0 -->
  <script>
  import addTraceModule from './modules/addTraceModule'
  import addTraceTemplate from './modules/addTraceTemplate'
  import { UDIListMixin } from './mixins/UDIListMixin'
  import JDate from '@/components/jeecg/JDate'
  import { certificateDelete, getTraceModuleInfo, delTraceModule, getTemplateList } from '@/api/api'
  import Vue from 'vue'
  export default {
    name: 'VendorList',
    mixins: [UDIListMixin],
    components: {
        addTraceModule,
        addTraceTemplate
    },
    data() {
      return {
        selectedRowKeys: [],
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
          offset: 1,
        },
        // 查询条件
        queryParam: {},
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        // 表头
        columns: [
          { title: '模版名称', dataIndex: 'templateName', width: 70, align: 'left' },
          { title: '备注', dataIndex: 'remark', width: 70, align: 'left' },
          {
            title: '操作',
            dataIndex: 'action',
            width: 280,
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '/formTemplate/list',
          delete: '/unit/certificateDelete',
          deleteBatch: '/supplier/deleteBatch',
          importExcelUrl: '/supplier/importVendor',
          exportXlsUrl: '/supplier/exportExcel',
          batchSetStatusUrl: '/formTemplate/modifyStatus',
        },
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
      },
    },
    created() {
    },
    methods: {
      changetime(createTime) {
        return createTime.substring(0, 10)
      },
      //   新增模版
      handleAddModule(record){
          this.$refs.addTraceModule.add(record)
      },
      // 获取模版信息
      async getModuleInfo(){
          const params = {
              "fileName": "1733462762267.vue"
          }
          const res = await getTraceModuleInfo(params)
          // 如果 response 不是 Blob，则转换为 Blob（这里假设是 ArrayBuffer）
          const blob = res instanceof Blob ? res : new Blob([res]);
          // 创建一个指向 Blob 的下载链接
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'filename.vue'; // 设置下载的文件名
          document.body.appendChild(a);
          a.click(); // 触发下载
          // 清理：释放 URL 对象
          setTimeout(() => {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
          }, 0);
          console.log(blob,typeof(blob),'模版信息====================')
          this.$refs.addTraceModule.add(blob)
      },
      // 删除
      handleDelete(id) {
        try {
          this.$confirm('是否删除该模版?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            // 用户点击了确定按钮
            this.deleteModule(id);
          }).catch(() => {
            // 用户点击了取消按钮或关闭了对话框
            console.log('取消删除');
          });
        } catch (err) {
          console.error('确认对话框取消或出错:', err);
        }
      },
      deleteModule(id){
        const params = {
          id: id,
          status: 3
        }
        delTraceModule(params).then(res => {
          if (res.success) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      searchReset() {
        this.queryParam = {
          // type: '供应商',
        }
        this.loadData(1)
      },
      modalTemplateOk(){
        this.loadData()
      },
      handleImportXls() {
        let importExcelUrl = this.url.importExcelUrl
        let templateUrl = '/doc/vendor_template.xls'
        let templateName = '供应商Excel模板[下载]'
        this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
        this.$refs.modalImportForm.title = '供应商导入'
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = '编辑'
        this.$refs.modalForm.disableSubmit = false
        if (this.btnEnableList.indexOf(1) === -1) {
          this.$refs.modalForm.isReadOnly = true
        }
      },
      onSelectChange(selectedRowKeys){
        this.selectedRowKeys = selectedRowKeys;
        console.log(this.selectedRowKeys,'选中的值==============')
        // 触发自定义事件，并将选中的行键传递给父组件
        this.$emit('update:selectRows', selectedRowKeys);
      }
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  </style>